module.exports = __webpack_public_path__ + "images/MuleSoft-356fe9.png";